<template>
  <div class="main-wrapper">
    <table>
      <tr v-if="!isIP">
        <td class="bold-text">Полное наименование</td>
        <td>
          <textarea
            class="textarea-input"
            v-model="data.ORG_FULL_NAME"
            disabled
          ></textarea>
        </td>
      </tr>
      <tr v-if="isIP">
        <td class="bold-text">ФИО индивидуального предпринимателя</td>
        <td>
          <textarea
            class="textarea-input"
            v-model="data.ORG_FULL_NAME"
            disabled
          ></textarea>
        </td>
      </tr>
      <tr v-if="!isIP">
        <td class="bold-text">Сокращенное наименование</td>
        <td>
          <input
            class="input-line"
            type="text"
            v-model="data.ORG_BRIEF_NAME"
            disabled
          />
        </td>
      </tr>
      <tr>
        <td class="bold-text">Дата гос.регистрации</td>
        <td>
          <input
            class="input-line"
            type="text"
            v-model="data.REG_DATE"
            disabled
          />
        </td>
      </tr>
      <tr>
        <td class="bold-text">ИНН</td>
        <td>
          <input class="input-line" type="text" v-model="data.INN" disabled />
        </td>
      </tr>
      <tr v-if="!isIP">
        <td class="bold-text">КПП</td>
        <td>
          <input class="input-line" type="text" v-model="data.KPP" disabled />
        </td>
      </tr>
      <tr v-if="!isIP">
        <td class="bold-text">ОГРН</td>
        <td>
          <input class="input-line" type="text" v-model="data.OGRN" disabled />
        </td>
      </tr>
      <tr v-if="!isIP">
        <td class="bold-text">Дата выдачи ОГРН</td>
        <td>
          <input
            class="input-line"
            type="text"
            v-model="data.OGRN_DATE"
            disabled
          />
        </td>
      </tr>
      <tr v-if="isIP">
        <td class="bold-text">ОГРНИП</td>
        <td>
          <input class="input-line" type="text" v-model="data.OGRN" disabled />
        </td>
      </tr>
      <tr v-if="isIP">
        <td class="bold-text">Дата выдачи ОГРНИП</td>
        <td>
          <input
            class="input-line"
            type="text"
            v-model="data.OGRN_DATE"
            disabled
          />
        </td>
      </tr>
      <tr>
        <td class="bold-text">Регистрирующий орган</td>
        <td>
          <textarea
            class="textarea-input"
            v-model="data.REG_ORGAN_NAME"
            disabled
          ></textarea>
        </td>
      </tr>
      <tr v-if="!isIP">
        <td class="bold-text">ОПФ</td>
        <td>
          <textarea
            class="textarea-input"
            v-model="data.OPF"
            disabled
          ></textarea>
        </td>
      </tr>
      <tr>
        <td class="bold-text">ОКВЭД (основной)</td>
        <td>
          <input
            class="input-line"
            type="text"
            v-model="data.MAIN_OKVED"
            disabled
          />
        </td>
      </tr>
      <tr>
        <td class="bold-text">ОКВЭД (дополнительный)</td>
        <td>
          <textarea
            class="textarea-input"
            v-model="data.AUX_OKVEDS"
            disabled
          ></textarea>
        </td>
      </tr>
      <tr v-if="!isIP">
        <td class="bold-text">Место нахождения юридического лица</td>
        <td>
          <textarea
            class="textarea-input"
            v-model="data.ARTICLES_ASSOCIATION_ADDR"
            disabled
          ></textarea>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <span
              :class="
                sendData.REAL_MAIN_OKVED != null &&
                sendData.REAL_MAIN_OKVED.length > 0
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Фактический вид деятельности, занимающий более 50 % доходов
          </p>
        </td>
        <td>
          <textarea
            class="textarea-input"
            v-model="sendData.REAL_MAIN_OKVED"
            @input="
              sendData.REAL_MAIN_OKVED.length > 255
                ? (sendData.REAL_MAIN_OKVED = sendData.REAL_MAIN_OKVED.substr(
                    0,
                    255
                  ))
                : sendData.REAL_MAIN_OKVED
            "
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('REAL_MAIN_OKVED') != -1
            "
          ></textarea>
        </td>
      </tr>
      <tr>
        <td>
          <p>
            <span
              :class="
                (sendData.REAL_AUX_OKVEDS != null &&
                  sendData.REAL_AUX_OKVEDS.length > 0) ||
                has_real_main_okved
                  ? 'valid-field'
                  : 'unvalid-field'
              "
              >➤</span
            >
            Фактические дополнительные виды деятельности
          </p>
          <label
            ><input
              type="checkbox"
              class="table-checkbox"
              v-model="has_real_main_okved"
              @click="sendData.REAL_AUX_OKVEDS = ''"
              :disabled="
                pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('REAL_AUX_OKVEDS') != -1
              "
            />Фактические дополнительные виды деятельности отсутствуют</label
          >
        </td>
        <td>
          <textarea
            class="textarea-input"
            v-model="sendData.REAL_AUX_OKVEDS"
            @input="
              sendData.REAL_AUX_OKVEDS.length > 255
                ? (sendData.REAL_AUX_OKVEDS = sendData.REAL_AUX_OKVEDS.substr(
                    0,
                    255
                  ))
                : sendData.REAL_AUX_OKVEDS
            "
            :disabled="
              has_real_main_okved ||
                (pageInfo.DISABLED != null &&
                  pageInfo.DISABLED.indexOf('REAL_AUX_OKVEDS') != -1)
            "
          ></textarea>
        </td>
      </tr>
      <tr v-if="!isIP">
        <td class="bold-text">Уставный капитал, руб.</td>
        <td>
          <input
            class="input-line"
            type="text"
            v-model="data.AUTHORIZED_CAPITAL"
            disabled
          />
        </td>
      </tr>
      <tr>
        <td class="bold-text">Налоговый орган</td>
        <td>
          <textarea
            class="textarea-input"
            v-model="data.TAX_ORGAN"
            disabled
          ></textarea>
        </td>
      </tr>
      <tr v-if="!isIP">
        <td>
          Сведения о присутствии или отсутствии по адресу клиента - юридического
          лица, указанному в ЕГРЮЛ
        </td>
        <td>
          <textarea
            class="textarea-input"
            v-model="data.UR_ADDRESS_IVALID_INFO"
            disabled
          ></textarea>
        </td>
      </tr>
    </table>

    <div class="main-wrapper-licences">
      <p v-if="licences.length == 0">
        Лицензии, полученные из ЕГРЮЛ, отсутствуют
      </p>
      <div class="licences-list" v-if="licences.length != 0">
        <div v-for="item in licences" :key="item.LIC_NUMBER">
          <div
            class="show-title"
            @click="
              item.show = !item.show;
              clickShow = true;
            "
          >
            <p>
              <span
                :class="
                  (item.LIC_DURATION_DATE != null &&
                    item.LIC_DURATION_DATE.length == 10 &&
                    !item.unvalidDateTo) ||
                  item.hasDate
                    ? 'valid-field'
                    : 'unvalid-field'
                "
                >➤</span
              >
              Лицензия №{{ item.LIC_NUMBER }} ({{ item.LIC_ISSUER }})
            </p>
            <div class="icons-lic">
              <i class="fa fa-angle-up" v-if="item.show"></i>
              <i class="fa fa-angle-down" v-if="!item.show"></i>
            </div>
          </div>
          <table class="table-licences" v-show="item.show">
            <tr class="tr-licences">
              <td class="left-column">
                <p>Дата начала действия лицензии</p>
              </td>
              <td class="right-column">
                <input type="text" v-model="item.LIC_DATE" disabled />
              </td>
            </tr>
            <tr>
              <td class="td-licences">
                <p>
                  <span
                    :class="
                      (item.LIC_DURATION_DATE != null &&
                        item.LIC_DURATION_DATE.length == 10 &&
                        !item.unvalidDateTo) ||
                      item.hasDate
                        ? 'valid-field'
                        : 'unvalid-field'
                    "
                    >➤</span
                  >
                  Дата окончания действия лицензии
                </p>
                <label>
                  <input
                    type="checkbox"
                    v-model="item.hasDate"
                    id="checkboxEnglishName"
                    @click="
                      item.LIC_DURATION_DATE = '';
                      isUpdate = true;
                    "
                    :disabled="item.DISABLED != null && item.DISABLED"
                  />
                  Дата окончания действия лицензии отсутствует
                </label>
              </td>
              <td class="td-licences">
                <input
                  type="text"
                  v-model="item.LIC_DURATION_DATE"
                  :disabled="item.hasDate"
                  v-mask="'##.##.####'"
                  placeholder="дд.мм.гггг"
                  @input="dateChanged(item)"
                  @blur="checkToDate(item)"
                />
                <p class="necessary-message" v-if="item.unvalidDateTo">
                  Введите корректную окончания действия лицензии
                </p>
              </td>
            </tr>
            <tr class="tr-licences">
              <td class="td-licences">
                <p>Описание</p>
              </td>
              <td class="td-licences">
                <textarea
                  class="textarea-input"
                  v-model="item.LIC_DESCRIPTION"
                  disabled
                ></textarea>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="patents">
        <p>
          <span
            :class="
              hasLicensesOrPatents[0] || hasLicensesOrPatents[1]
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Лицензии (разрешения) на право осуществления деятельности, подлежащей
          лицензированию, если данные лицензии (разрешения) имеют
          непосредственное отношение к правоспособности клиента заключать
          договор, на основании которого открывается счет, не включенные в
          {{ isIP ? "ЕГРИП" : "ЕГРЮЛ" }} (необходимо указать все лицензии):
        </p>
        <label>
          <input
            type="checkbox"
            v-model="hasLicensesOrPatents[0]"
            @click="hasLicensesOrPatents = [hasLicensesOrPatents[0], false]"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('INTERNAL_LICENCES') != -1
            "
          />ДА
        </label>
        <label>
          <input
            type="checkbox"
            v-model="hasLicensesOrPatents[1]"
            @click="hasLicensesOrPatents = [false, hasLicensesOrPatents[1]]"
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('INTERNAL_LICENCES') != -1
            "
          />НЕТ
        </label>
        <div v-if="hasLicensesOrPatents[0]">
          <p class="necessary-table-not" v-if="!checkFiles()">
            Заполните хотя бы одну строку таблицы.
          </p>
          <p class="min-one-file">
            Вы можете приложить только один файл или архив. Если необходимо
            приложить несколько документов, добавьте документы в архив и
            прикрепите архив.
          </p>
          <table class="patent-table">
            <tr>
              <td class="patent-td" width="15px"></td>
              <td class="patent-td">Наименование</td>
              <td class="patent-td" width="260px">Файл</td>
            </tr>
            <tr v-for="document in documents" :key="document.id">
              <td class="patent-td">
                <span
                  :class="checkRow(document) ? 'valid-field' : 'unvalid-field'"
                  >➤</span
                >
              </td>
              <td class="patent-td">
                <input
                  type="text"
                  v-model="document.CAPTION"
                  :onchanged="
                    document.CAPTION != null && document.CAPTION.length > 80
                      ? (document.CAPTION = document.CAPTION.substr(0, 80))
                      : document.CAPTION
                  "
                  @blur="addRow(document.id)"
                  :disabled="document.DISABLED != null && document.DISABLED"
                />
              </td>
              <td min-width="250px" class="last-column">
                <input
                  v-show="document.FILE == null"
                  type="file"
                  id="file"
                  ref="file"
                  accept="image/*, .pdf, .zip, .7z, .xls, .xlsx"
                  v-on:change="fileUpload(document.id)"
                  @click="document.FILE = null"
                  :disabled="document.DISABLED != null && document.DISABLED"
                />
                <div
                  class="file-name-icon"
                  v-if="document.FILE != null"
                  @click="onClickBan(document.id)"
                  :disabled="document.DISABLED != null && document.DISABLED"
                >
                  <div class="icons">
                    <i class="fa fa-trash"></i>
                  </div>
                  <p class="file-name">{{ document.FILE.name }}</p>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <p class="necessary-table-not" v-if="!(dataIsRight[0] || dataIsRight[1])">
        Подтвердите корректность данных, заполненных автоматически.
      </p>
      <div class="data-is-right-checkboxes">
        <label>
          <input
            type="checkbox"
            v-model="dataIsRight[0]"
            @click="
              dataIsRight = [dataIsRight[0], false];
              invalidData = '';
            "
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('EGRUL_DATA_VALID') != -1
            "
          />Данные верны
        </label>
        <label>
          <input
            type="checkbox"
            v-model="dataIsRight[1]"
            @click="
              dataIsRight = [false, dataIsRight[1]];
              invalidData = '';
            "
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('EGRUL_DATA_VALID') != -1
            "
          />Внести изменения
        </label>
      </div>
      <div v-show="dataIsRight[1]" class="invalid-data">
        <p class="necessary-bold">
          <span
            :class="
              (invalidData != null && invalidData.length > 0) || !dataIsRight[1]
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Укажите строку, в которой указаны неверные данные и укажите верные
          данные
        </p>
        <textarea
          class="invalid-data-textarea"
          v-model="invalidData"
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('EGRUL_INFO_MAIN_INVALID_DATA') != -1
          "
        ></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import dateConventer from "./utils/date-converter.js";
import mask from "./utils/my-mask.js";
export default {
  name: "EgrulInfoMain",
  props: {
    pageInfo: {},
    pageName: String,
    isIP: Boolean,
  },
  data: () => ({
    dataIsRight: [false, false],
    invalidData: "",
    has_real_main_okved: false,
    unvalidCheckOkved: [],
    unvalidMainOkved: false,
    okveds: [],
    licences: [],
    clickShow: false,
    hasLicensesOrPatents: [false, false],
    documents: [],
    sendData: {
      REAL_MAIN_OKVED: null,
      REAL_AUX_OKVEDS: "",
      EGRUL_DATA_VALID: false,
    },
    data: {},
  }),
  methods: {
    fillSendData(data) {
      this.sendData.ID = data.ID;
      this.sendData.INN = data.INN;
      
      this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
      if (data.EGRUL_DATA_VALID != null)
        data.EGRUL_DATA_VALID
          ? (this.dataIsRight = [true, false])
          : (this.dataIsRight = [false, true]);

      this.sendData.REAL_MAIN_OKVED = data.REAL_MAIN_OKVED;
      if (data.REAL_AUX_OKVEDS != null && data.REAL_AUX_OKVEDS.length > 0)
        this.sendData.REAL_AUX_OKVEDS = data.REAL_AUX_OKVEDS;
      else if (data.REAL_MAIN_OKVED != null) this.has_real_main_okved = true;
      if (
        data.EGRUL_INFO_MAIN_INVALID_DATA != null &&
        data.EGRUL_INFO_MAIN_INVALID_DATA.length > 0
      )
        this.invalidData = data.EGRUL_INFO_MAIN_INVALID_DATA;

      if (data.UR_ADDRESS_IVALID_INFO != null)
        this.data.UR_ADDRESS_IVALID_INFO = data.UR_ADDRESS_IVALID_INFO;
      if (data.REG_DATE != null) {
        this.data.REG_DATE = dateConventer.fromServerConvert(data.REG_DATE);
      }
      this.data.REG_ORGAN_NAME = data.REG_ORGAN_NAME;
      this.data.ORG_FULL_NAME = data.ORG_FULL_NAME;
      this.data.KPP = data.KPP;
      this.data.OGRN = data.OGRN;
      this.data.ORG_BRIEF_NAME = data.ORG_BRIEF_NAME;
      this.data.AUX_OKVEDS = data.AUX_OKVEDS;
      this.data.ARTICLES_ASSOCIATION_ADDR = data.ARTICLES_ASSOCIATION_ADDR;
      if (data.OGRN_DATE != null) {
        this.data.OGRN_DATE = dateConventer.fromServerConvert(data.OGRN_DATE);
      }
      this.data.TAX_ORGAN = data.TAX_ORGAN;
      this.data.MAIN_OKVED = data.MAIN_OKVED;
      this.data.AUTHORIZED_CAPITAL = data.AUTHORIZED_CAPITAL;
      this.data.INN = data.INN;
      this.data.OPF = data.OPF;
    },
    checkOkvedInOkveds(okved) {
      let a = false;
      this.okveds.forEach((item) => (a = a || item == okved));
      if (!a && okved.length > 0) this.unvalidCheckOkved.push(okved);
    },
    checkOkveds() {
      this.unvalidCheckOkved = [];
      if (this.sendData.REAL_AUX_OKVEDS != null) {
        let okveds = this.sendData.REAL_AUX_OKVEDS.split(" ");
        for (let i = 0; i < okveds.length; i++) {
          this.checkOkvedInOkveds(okveds[i]);
        }
      }
    },
    checkMainOkved() {
      let a = false;
      this.okveds.forEach((item) => {
        a = a || this.sendData.REAL_MAIN_OKVED == item;
      });

      this.unvalidMainOkved =
        !a &&
        this.sendData.REAL_MAIN_OKVED != null &&
        this.sendData.REAL_MAIN_OKVED.length > 0;
    },
    validation() {
      var msg = "";
      if (
        this.sendData.REAL_MAIN_OKVED == null ||
        this.sendData.REAL_MAIN_OKVED.length == 0
      )
        msg +=
          "Необходимо заполнить поля:<br>• Фактический вид деятельности, занимающий более 50 % доходов<br>";
      if (
        !this.has_real_main_okved &&
        (this.sendData.REAL_AUX_OKVEDS == null ||
          this.sendData.REAL_AUX_OKVEDS.length == 0)
      )
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Фактические дополнительные виды деятельности<br>"
            : "• Фактические дополнительные виды деятельности<br>";
      if (
        this.dataIsRight[1] &&
        (this.invalidData == null || this.invalidData == 0)
      )
        msg +=
          "Укажите строку, в которой указаны неверные данные и укажите верные данные<br>";
      if (!(this.dataIsRight[0] || this.dataIsRight[1]))
        msg += "Подтвердите корректность данных, заполненных автоматически<br>";
      this.licences.forEach((item) => {
        if (
          (item.LIC_DURATION_DATE == null ||
            item.LIC_DURATION_DATE.length == 0 ||
            item.unvalidDateTo) &&
          !item.hasDate
        )
          msg +=
            "Для лицензия №" +
            item.LIC_NUMBER +
            " корректно укажите дату окончания её действия<br>";
      });
      if (
        this.dataIsRight[1] &&
        (this.invalidData == null || this.invalidData.length == 0)
      )
        msg +=
          "• Укажите строку, в которой указаны неверные данные и укажите верные данные<br>";
      if (!(this.hasLicensesOrPatents[0] || this.hasLicensesOrPatents[1]))
        msg += "Укажите наличие лицензий (патентов)";
      if (this.hasLicensesOrPatents[0] && !this.checkFiles())
        msg += "Заполните хотя бы одну строку таблицы";
      this.$emit("enableButtons", true, msg);
      if (msg.length == 0) {
        this.sendData.FILES = this.createFileList();
        this.sendData.INTERNAL_LICENCES = this.hasLicensesOrPatents[0];
        this.sendData.LICENCES = this.licences;
        this.sendData.EGRUL_DATA_VALID = this.dataIsRight[0];
        if (!this.sendData.EGRUL_DATA_VALID)
          this.sendData.EGRUL_INFO_MAIN_INVALID_DATA = this.invalidData;
        else delete this.sendData.EGRUL_INFO_MAIN_INVALID_DATA;
        this.$emit(
          "changePageSendData",
          this.sendData,
          this.sendData.FILES != null && this.sendData.FILES.length > 0
        );
      }
    },
    onSelectType(document, event) {
      document.CAPTION = event.name;
    },
    onClickBan(id) {
      if (this.documents[id].DISABLED == null || !this.documents[id].DISABLED) {
        this.documents[id].FILE = null;
        let input = this.$refs.file[id];
        input.type = "text";
        input.type = "file";
        this.$emit("updateFiles", this.rows);
      }
    },
    fileUpload(id) {
      if (this.checkFilesHas(id, this.$refs.file[id].files[0])) {
        let input = this.$refs.file[id];
        input.type = "text";
        input.type = "file";
      } else {
        this.documents[id].FILE = this.$refs.file[id].files[0];
        this.addRow(id);
      }
      this.validation();
      this.$emit("updated");
    },
    addRow(id) {
      if (
        this.documents[id].FILE != null &&
        this.documents[id].CAPTION != null &&
        this.documents[id].CAPTION.length > 0 &&
        id == this.documents.length - 1
      )
        this.documents.push({
          id: this.documents.length,
          CAPTION: "",
          FILE: null,
        });
    },
    checkFilesHas(id, file) {
      let a = false;
      this.documents.forEach((item) => {
        if (item.FILE != null) {
          a = a || item.FILE.name == file.name;
        }
      });
      if (a) this.$alert("Файл " + file.name + " уже загружен");
      else if (file.size > 31457280) {
        this.$alert(
          "Размер файла " + file.name + " превышает допустимый размер (30 МБ)"
        );
        a = true;
      }
      return a;
    },
    checkRow(item) {
      return item.CAPTION.length > 0 && item.FILE != null;
    },
    checkFiles() {
      let a = false;
      this.documents.forEach((item) => {
        a = a || this.checkRow(item);
      });
      return a;
    },
    createFileList() {
      let files = [];
      this.documents.forEach((item) => {
        var a = true;
        if (this.pageInfo.FILES != null) {
          this.pageInfo.FILES.forEach((file) => {
            if (
              file.DESCRIPTION == item.CAPTION &&
              item.FILE != null &&
              item.FILE.name == file.DS_FILE_NAME
            ) {
              a = false;
            }
          });
        }
        if (a && item.FILE != null) {
          files.push(item);
        }
      });
      if (this.pageInfo.FILES != null)
        this.pageInfo.FILES.forEach((file) => {
          var a = true;
          this.documents.forEach((item) => {
            if (item.CAPTION == file.DESCRIPTION && item.FILE != null)
              a = false;
          });
          if (a) {
            files.push({ FILE: null, CAPTION: file.DESCRIPTION });
          }
        });
      return files;
    },
    dateChanged(info) {
      if (info.LIC_DURATION_DATE != this.checkDate(info.LIC_DURATION_DATE))
        info.LIC_DURATION_DATE = this.checkDate(info.LIC_DURATION_DATE);
      if (info.LIC_DURATION_DATE != null && info.LIC_DURATION_DATE.length == 10)
        this.checkToDate(info);
      else info.unvalidDateTo = false;
    },
    checkDate(date) {
      return mask.date(date);
    },
    checkToDate(info) {
      var birthDate;
      if (info.LIC_DURATION_DATE != null) birthDate = info.LIC_DURATION_DATE;
      else birthDate = "";
      let year = parseInt(info.LIC_DATE.split(".")[2]);
      let month = parseInt(info.LIC_DATE.split(".")[1]);
      let day = parseInt(info.LIC_DATE.split(".")[0]);

      let dul_year = parseInt(birthDate.split(".")[2]);
      let dul_months = parseInt(birthDate.split(".")[1]);
      let dul_days = parseInt(birthDate.split(".")[0]);
      if (birthDate.length == 10) {
        info.unvalidDateTo = !(
          dul_year > year ||
          (dul_year == year && dul_months > month) ||
          (dul_year == year && dul_months == month && dul_days > day)
        );
      } else if (birthDate.length == 0) {
        info.unvalidDateTo = false;
      } else {
        info.unvalidDateTo = true;
      }
    },
  },
  async created() {
    try {
      this.fillSendData(this.pageInfo);
      if (this.pageInfo.OKVEDS != null)
        for (let i = 0; i < this.pageInfo.OKVEDS.length; i++)
          this.okveds.push(this.pageInfo.OKVEDS[i]);
      if (this.pageInfo.LICENCES != null) {
        this.pageInfo.LICENCES.forEach((element) => {
          element.show = false;
          element.unvalidDateTo = false;
          if (element.LIC_DURATION_DATE == null) element.LIC_DURATION_DATE = "";
          else
            element.LIC_DURATION_DATE = dateConventer.fromServerConvert(
              element.LIC_DURATION_DATE
            );
          if (element.LIC_DATE == null) element.LIC_DATE = "";
          else
            element.LIC_DATE = dateConventer.fromServerConvert(
              element.LIC_DATE
            );
        });
        this.licences = JSON.parse(JSON.stringify(this.pageInfo.LICENCES));
      }
      if (this.pageInfo.INTERNAL_LICENCES != null)
        this.hasLicensesOrPatents = [
          this.pageInfo.INTERNAL_LICENCES,
          !this.pageInfo.INTERNAL_LICENCES,
        ];
      if (this.pageInfo.FILES != null) {
        let files = this.pageInfo.FILES;
        files.forEach((item) => {
          this.documents.push({
            id: this.documents.length,
            CAPTION: item.DESCRIPTION,
            FILE: { name: item.DS_FILE_NAME },
            DISABLED: item.DISABLED,
          });
        });
      }
      let a = false;
      this.documents.forEach(
        (i) => (a = (i.DISABLED != null && i.DISABLED) || a)
      );
      this.documents.push({
        id: this.documents.length,
        CAPTION: "",
        FILE: null,
        DISABLED: a,
      });
      this.validation();
    } catch (error) {
      console.log(error);
    }
  },
  updated() {
    this.validation();
    this.$emit("updated");
  },
  beforeDestroy() {
    this.$emit("sendToServer", this.pageName, this.sendData);
  },
};
</script>

<style scoped>
tr {
  border-top: 1px solid #cccccc;
}
p {
  width: 100%;
}
table {
  text-align: left;
}
.bold-text {
  font-weight: bold;
  width: 30%;
  padding-right: 10px;
}
.data-is-right-checkboxes {
  text-align: center;
  padding: 5px 0px;
}
p {
  font-weight: bold;
  margin-right: 10px;
}
.necessary-message {
  color: red;
  font-size: 12px;
}
.input-line {
  border: none;
  border-bottom: 1px solid #cccccc;
  position: relative;
}
.input-line:focus,
.necessary-valid:focus,
.necessary-unvalid:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
.necessary-unvalid {
  border: none;
  border-bottom: 1px solid red;
  width: 75%;
}
.necessary-valid {
  border: none;
  width: 75%;
  border-bottom: 1px solid #cccccc;
}
.data-is-right-checkboxes {
  text-align: center;
  padding: 5px 0px;
}
.show-title {
  margin-top: 10px;
  cursor: default;
  text-align: center;
  border: 1px solid #555555;
}
.icons-lic {
  background-color: transparent;
  border: none;
  color: black;
  position: relative;
  font-size: 15px;
}
.td-licences {
  padding: 5px 10px;
}
.tr-licences {
  border-top: 1px solid #555555;
}
textarea {
  width: 98%;
}
.table-licences,
.patent-table {
  border-collapse: collapse;
  border-left: 1px solid #555555;
  border-bottom: 1px solid #555555;
  border-right: 1px solid #555555;
  padding: 0px 5px;
}
.left-column {
  width: 30%;
  padding: 5px 10px;
  text-align: justify;
}
.right-column {
  width: 70%;
  text-align: center;
}
.licences-list {
  margin-top: 10px;
  text-align: justify;
}
.patents {
  text-align: justify;
}
input[type="text"] {
  border: none;
  width: 98%;
  border-bottom: 1px solid #cccccc;
}
input[type="text"]:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
.patent-td {
  max-width: 400px;
  border: 1px solid black;
  padding: 5px 10px;
}
.patent-table {
  margin-top: 10px;
  max-width: 1000px;
  width: 70%;
  margin: 0 auto;
  text-align: center;
  border-collapse: collapse;
}
.min-one-file {
  text-align: center;
  font-size: 12px;
}
.icons {
  position: absolute;
  padding-left: 255px;
  padding-top: 5px;
  background-color: white;
  border: none;
  color: red;
  font-size: 17px;
}
.last-column {
  border: 1px solid #555555;
}
.file-name-icon {
  width: 250px;
}
.main-wrapper-licences {
  width: 100%;
}
</style>
